import { Component } from '@angular/core';

import { FirebaseService } from '../../services/firebase.service';

import { Preferences } from '../../models/preferences';

@Component({
	selector    : 'settings',
	templateUrl : 'settings.html',
	styleUrls   : [ 'settings.scss' ]
})

export class SettingsComponent {
  username    : string;
  newUsername : string;
  email       : string;
  preferences : Preferences = {
    abbreviations : true,
    fractions     : true
  };

	constructor(
    private firebaseService : FirebaseService
  ) {
    this.initUser();
  }

  initUser(counter : number = 0) : void {
    if (this.firebaseService.user) {
      this.firebaseService.user
        .subscribe(user => {
          this.username    = this.newUsername = user.displayName || user.email;
          this.email       = user.email;
          this.preferences = user.preferences;
        });
    } else if (counter++ < 100) {
      setTimeout(() => this.initUser(counter), 10);
    }
  }

  save() {
  	this.firebaseService.updateUser({
      displayName : this.newUsername
    })
    .then(() => this.username = this.newUsername);
  }

  updatePreferences(event) {
    let changes : object = {};

    changes[event.target.name] = event.target.checked;

    this.firebaseService.updatePreferences(changes);
  }
}


// WEBPACK FOOTER //
// /Users/briznad/Documents/WebDev/personal/cartmigo/cartmigo-beta/src/app/components/settings/settings.ts